"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDuesSponsoredOrgContext = void 0;
var react_1 = require("react");
var DuesSponsoredOrgContext_1 = require("../contexts/DuesSponsoredOrgContext");
//This custom hook is responsible for consuming the DuesSponsoredOrgContext.
function useDuesSponsoredOrgContext() {
    var context = (0, react_1.useContext)(DuesSponsoredOrgContext_1.DuesSponsoredOrgContext);
    if (!context) {
        throw new Error('The useDuesSponsoredOrgContext must be used within an DuesSponsoredOrgProvider.');
    }
    return context;
}
exports.useDuesSponsoredOrgContext = useDuesSponsoredOrgContext;
//# sourceMappingURL=useDuesSponsoredOrgContext.js.map